import axios from "axios";
import { useMutation } from '@tanstack/react-query';
import { apiUrl } from "../../config";


export const useCheckForValidToken = () => {
    return useMutation({
        mutationFn: checkForValidTokenRequest,
        onError: (error) => {
            console.error('❌ Error checking for valid token:', error);
        },
        // onSuccess: (data) => {
        //     console.log('Token check success!:', data);
        // },
    });
};


const checkForValidTokenRequest = async () => {
    const authorizationHeader = localStorage.getItem('authorization');
    //console.log("🪪 Authorization Header:", authorizationHeader);
    
    const response = await axios.post(
        `${apiUrl}/user/check-token-expiration`, // Adjust the endpoint as needed
        {},
        {
            headers: {
                Authorization: authorizationHeader, // Include the authorization header in the request
                'Content-Type': 'application/json'
            }
        }
    );
    //console.log('✅ Token check response:', response.data);
    return response.data; // Return the response data
}